module.exports = __webpack_public_path__ + "static/media/0048.e82dfe99.png";